var _path, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHotelPin = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 48,
  height: 60,
  viewBox: "0 0 48 60",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M24 57C24 57 4 37.5 4 23C4 11.954 12.954 3 24 3C35.046 3 44 11.954 44 23C44 37.5 24 57 24 57Z",
  fill: "#003399",
  stroke: "#3D8BF2",
  strokeWidth: 3,
  strokeLinejoin: "round"
})), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 23,
  r: 7.5,
  fill: "#ffffff"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgHotelPin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/hotel-pin.5432977b22d0452439a867e58bcb5bed.svg";